import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import {
  convertDateWithValidation,
  validate,
} from "../../helper/losDataHelper";
import { useState } from "react";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const LegalDetail = ({ legalDetailsList }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const maxSteps = validate(legalDetailsList) ? legalDetailsList.length : 0;

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const legalDetailsComponent = () => {
    const legalDetails = validate(legalDetailsList)
      ? legalDetailsList[activeStep]
      : undefined;
    return (
      <Grid container rowSpacing={0} columnSpacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Internal Application ID"
            variant="standard"
            placeholder="Enter Internal Application ID"
            disabled={true}
            value={
              legalDetails !== undefined
                ? legalDetails.internalApplicationId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Internal Legal ID"
            variant="standard"
            placeholder="Enter Internal Legal ID"
            disabled={true}
            value={
              legalDetails !== undefined ? legalDetails.internalLegalId : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Internal Applicant ID"
            variant="standard"
            placeholder="Enter Internal Applicant ID"
            disabled={true}
            value={
              legalDetails !== undefined ? legalDetails.internalApplicantId : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Application Number"
            variant="standard"
            placeholder="Enter Application Number"
            disabled={true}
            value={
              legalDetails !== undefined ? legalDetails.applicationNumber : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Customer ID"
            variant="standard"
            placeholder="Enter Customer ID"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.customerId : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Property ID"
            variant="standard"
            placeholder="Enter Property ID"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.propertyId : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Appriser Type ID"
            variant="standard"
            placeholder="Enter Appriser Type ID"
            disabled={true}
            value={
              legalDetails !== undefined ? legalDetails.appriserTypeId : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Appriser Code"
            variant="standard"
            placeholder="Enter Appriser Code"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.appriserCode : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Appriser Name"
            variant="standard"
            placeholder="Enter Appriser Name"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.appriserName : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Appriser Mobile Number"
            variant="standard"
            placeholder="Enter Appriser Mobile Number"
            disabled={true}
            value={
              legalDetails !== undefined
                ? legalDetails.appriserMobileNumber
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Request Date"
            variant="standard"
            placeholder="Enter Request Date"
            disabled={true}
            value={
              validate(legalDetails)
                ? convertDateWithValidation(legalDetails.requestDate)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Primary Security Confirmation"
            variant="standard"
            placeholder="Enter Primary Security Confirmation"
            disabled={true}
            value={
              legalDetails !== undefined
                ? legalDetails.primarySecurityConfirmation
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Primary Security Confirmation Comments"
            variant="standard"
            placeholder="Enter Primary Security Confirmation Comments"
            disabled={true}
            value={
              legalDetails !== undefined
                ? legalDetails.primarySecurityConfirmationComments
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Title Clearance Comments"
            variant="standard"
            placeholder="Enter Title Clearance Comments"
            disabled={true}
            value={
              legalDetails !== undefined
                ? legalDetails.titleClearenceComments
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Response Date"
            variant="standard"
            placeholder="Enter Response Date"
            disabled={true}
            value={
              validate(legalDetails)
                ? convertDateWithValidation(legalDetails.responseDate)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="CLH Name"
            variant="standard"
            placeholder="Enter CLH Name"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.clhName : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Legal Clearance"
            variant="standard"
            placeholder="Enter Legal Clearance"
            disabled={true}
            value={
              legalDetails !== undefined ? legalDetails.legalClearance : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Legal Clearance Date"
            variant="standard"
            placeholder="Enter Legal Clearance Date"
            disabled={true}
            value={
              validate(legalDetails)
                ? convertDateWithValidation(legalDetails.legalClearanceDate)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="CLH Remarks"
            variant="standard"
            placeholder="Enter CLH Remarks"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.clhRemarks : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Legal Opinion Document"
            variant="standard"
            placeholder="Enter Legal Opinion Document"
            disabled={true}
            value={
              legalDetails !== undefined
                ? legalDetails.legalOpinionDocument
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Task Status"
            variant="standard"
            placeholder="Enter Task Status"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.taskStatus : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="CLH Task Status"
            variant="standard"
            placeholder="Enter CLH Task Status"
            disabled={true}
            value={legalDetails !== undefined ? legalDetails.clhTaskStatus : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Task State ID"
            variant="standard"
            placeholder="Enter Task State ID"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.taskStateId : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Task State"
            variant="standard"
            placeholder="Enter Task State"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.taskState : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Parent ID"
            variant="standard"
            placeholder="Enter Parent ID"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.parentId : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Credit Approved Date"
            variant="standard"
            placeholder="Enter Credit Approved Date"
            disabled={true}
            value={
              validate(legalDetails)
                ? convertDateWithValidation(legalDetails.creditApprovedDate)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Percentage (%)"
            variant="standard"
            placeholder="Enter Percentage (%)"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.percentage : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="External Can Do"
            variant="standard"
            placeholder="Enter External Can Do"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.externalCanDo : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Created By"
            variant="standard"
            placeholder="Enter Created By"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.createdBy : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Modified By"
            variant="standard"
            placeholder="Enter Modified By"
            disabled={true}
            value={validate(legalDetails) ? legalDetails.modifiedBy : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Created Date"
            variant="standard"
            placeholder="Enter Created Date"
            disabled={true}
            value={
              validate(legalDetails)
                ? convertDateWithValidation(legalDetails.createdDate)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Modified Date"
            variant="standard"
            placeholder="Enter Modified Date"
            disabled={true}
            value={
              validate(legalDetails)
                ? convertDateWithValidation(legalDetails.modifiedDate)
                : ""
            }
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <AccordianContainer id="accord" title="Legal Details" initialOpen={false}>
      <Box sx={{ marginTop: "-1%" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            {maxSteps > 1 && (
              <MobileStepper
                variant="text"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }}
                nextButton={
                  <Button
                    size="small"
                    sx={{ color: "#003f7c" }}
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    Next
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowLeft />
                    ) : (
                      <KeyboardArrowRight />
                    )}
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    sx={{ color: "#003f7c" }}
                    disabled={activeStep === 0}
                  >
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowRight />
                    ) : (
                      <KeyboardArrowLeft />
                    )}
                    Back
                  </Button>
                }
              />
            )}
          </Box>
        </Grid>
        {legalDetailsComponent()}
      </Box>
    </AccordianContainer>
  );
};

export default LegalDetail;
